import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogModule } from '@principle-theorem/ng-shared';
import { IMarketingCampaign } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import {
  CampaignEnrolmentSettingsComponent,
  ICampaignEnrolmentFormData,
} from '../campaign-enrolment-settings/campaign-enrolment-settings.component';

export interface ICampaignEnrolmentSettingsDialogRequest {
  campaign: WithRef<IMarketingCampaign>;
}

export interface ICampaignEnrolmentSettingsDialogResponse {
  formData: ICampaignEnrolmentFormData;
}

@Component({
  selector: 'pr-campaign-enrolment-settings-dialog',
  templateUrl: './campaign-enrolment-settings-dialog.component.html',
  styleUrl: './campaign-enrolment-settings-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgDialogModule, CampaignEnrolmentSettingsComponent],
})
export class CampaignEnrolmentSettingsDialogComponent {
  private _dialogRef = inject(
    MatDialogRef<
      CampaignEnrolmentSettingsDialogComponent,
      ICampaignEnrolmentSettingsDialogResponse
    >
  );
  data = inject<ICampaignEnrolmentSettingsDialogRequest>(MAT_DIALOG_DATA);
  formData = signal<ICampaignEnrolmentFormData | undefined>(undefined);

  submit(): void {
    const formData = this.formData();
    if (!formData) {
      return this._dialogRef.close();
    }
    this._dialogRef.close({ formData });
  }
}
